import { DigitalFormsTypes } from '@frontend/api-digital-forms';
import { contextFactory } from '@frontend/design-system';

export interface TemplatePreviewContextValue {
  template: DigitalFormsTypes.Schema.Template;
}

export const [TemplatePreviewContext, useTemplatePreviewContext] = contextFactory<TemplatePreviewContextValue>();
